import { defineStore } from 'pinia';
import { Process } from '@/domains/models/Process';

type State = {
  selectedApplications: Record<string, Partial<Process>>;
  selectedDates: Record<string, Array<Partial<Process>>>;
  selectedCardsByDate: Record<string, number>;
  allApplicationSelected: boolean;
  selected : boolean;
}

export const useApplicationsStore = defineStore('applications', {
  state: (): State => {
    return {
      selectedApplications: {},
      selectedDates: {},
      selectedCardsByDate : {},
      allApplicationSelected: false,
      selected : false,
    };
  },
  getters: {
    selectedApplicationsCount: state => Object.keys(state.selectedApplications).length,
  },
  actions: {
    setSelectedApplications(application: Pick<Process, '_id' | '_coder'>): void {
      this.selectedApplications = {
        ...this.selectedApplications,
        [application._id]: {
          _id: application._id,
          _coder: application._coder,
        },
      };
    },
    setSelectedDates(application: Pick<Process, '_id' | '_coder'>, date: string): void {
      // Check if the date already exists in selectedDates
      if (!this.selectedDates[date]) {
        // If not, initialize it with an empty array
        this.selectedDates[date] = [];
      }
    
      // Add the new application to the array for the given date
      this.selectedDates[date] = [
        ...this.selectedDates[date],
        {
          _id: application._id,
          _coder: application._coder,
        },
      ];
    },
    setSelectedCardsByDate(date: string): void {
      // Check if the date exists in selectedCardsByDate
      if (this.selectedCardsByDate[date]) {
        // Increment the value by 1
        this.selectedCardsByDate[date] += 1;
      } else {
        // If not, initialize it to 1
        this.selectedCardsByDate[date] = 1;
      }
    },
    decrementSelectedCardsByDate(date: string): void {
      // Check if the date exists in selectedCardsByDate
      if (this.selectedCardsByDate[date] && this.selectedCardsByDate[date] > 0) {
        // Decrement the value by 1
        this.selectedCardsByDate[date] -= 1;
      } else {
        // If not, initialize it to 1
        this.selectedCardsByDate[date] = 0;
      }
    },
    resetforSpecificDate(date: string): void {
      this.selectedCardsByDate[date] = 0
    },
    resetSelectedCardsByDate() : void {
      this.selectedCardsByDate = {}
    },
    removeByDate(date: string): void {
      // Check if the date exists in selectedDates
      if (this.selectedDates[date]) {
        // Delete the entry for the given date
        delete this.selectedDates[date];
      }
    },    
    removeApplicationFromSelectedApplications(applicationId: string): void {
      const obj = { ...this.selectedApplications };
      Reflect.deleteProperty(obj, applicationId);

      this.selectedApplications = obj;
    },
    resetApplications(): void {
      this.selectedApplications = {};
    },
    resetData(): void {
      this.selectedDates = {};
    },
    setAllApplications(applications: Process[]): void {
      const updatedApplications = applications.reduce(
        (acc, application) => {
          acc[application._id] = {
            _id: application._id,
            _coder: application._coder,
          };
          return acc;
        },
        {} as Record<string, Partial<Process>>,
      );
      this.selectedApplications = updatedApplications;
    },
    switchAllApplicationSelected(): void {
      this.allApplicationSelected = !this.allApplicationSelected;
    },
    switchSelected(): void {
      this.selected = !this.selected;
    },
    setSelected(state:boolean): void {
      this.selected = state;
    },
    resetAllApplicationSelected(){
      this.allApplicationSelected = false;
    }
  },
});
